import angular from 'angular';
import ngMaterial from 'angular-material';
import ngAnimate from 'angular-animate';
import ngAria from 'angular-aria';
import ngMessages from 'angular-messages';
import uiRouter from 'angular-ui-router';

import '../assets/css/main.css';
import '../assets/css/layout-wrap-shim.css';

import services from './services/index';
import ToolbarDirective from './toolbar/index';
import login from './login/index';
import dashboard from './dashboard/index';
import game from './game/index';
import character from './characters/index';
import scores from './scores/index';
import error from './error/index';
import cheat from './cheat/index';

let options = {
    strictDi:false
};

angular
    .module('kboGame',[
        ngMaterial,
        ngAnimate,
        ngAria,
        ngMessages,
        uiRouter,
        login,
        'ui.router.state.events',
        services,
        ToolbarDirective,
        dashboard,
        game,
        character,
        error,
        scores,
        cheat
    ])
    .config(($mdThemingProvider,$urlRouterProvider,$locationProvider)=>{
        "ngInject";
        $urlRouterProvider.otherwise('/home');
        $locationProvider.html5Mode(true);
        $mdThemingProvider.theme('default')
            .primaryPalette('light-blue', {
                'default': '800', // by default use shade 400 from the pink palette for primary intentions
                'hue-1': '100', // use shade 100 for the <code>md-hue-1</code> class
                'hue-2': '600', // use shade 600 for the <code>md-hue-2</code> class
                'hue-3': 'A100' // use shade A100 for the <code>md-hue-3</code> class
            })
            // If you specify less than all of the keys, it will inherit from the
            // default shades
            .accentPalette('purple', {
                'default': '200' // use shade 200 for default, and keep all other shades the same
            });
        $mdThemingProvider.theme('dark-red').backgroundPalette('red').dark();
        $mdThemingProvider.theme('dark-green').backgroundPalette('green').dark();
        $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();

    }).run(($state,$rootScope,SessionService,EventService)=>{
        'ngInject';
        SessionService.clear();
        EventService.subscribe('websocket:404',()=>{
           $state.go('error');
        });
        $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
            if (error.code === "AUTH_REQUIRED") {
                $state.go("login");
            }
        });
    });

if (process.env.ENV === 'production') {
    options.strictDi = true;
    angular.module('kboGame').config($compileProvider=>{
        "ngInject";
        $compileProvider.debugInfoEnabled(false);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);
    }).constant('socket',{
        url:'wss://racer.keyboardingonline.com/wss2/',
        debug:false,
        ping:true
    });
}else{
    angular.module('kboGame').constant('socket',{
        url:'ws://localhost:8008',
        debug:true,
        ping:false
    });
}

angular.element(document).ready(function () {
    angular.bootstrap(document, ['kboGame'],options);
});




// WEBPACK FOOTER //
// ./public/app/bootstrap.js